import { useEffect } from 'react';

const FreshDeskWidget = props => {
  const {
    environment,
    emailFrom,
    name,
    metadata
  } = props;
  useEffect(() => {
    if (window.FreshworksWidget) {
      window.FreshworksWidget('identify', 'ticketForm', {
        name: name,
        email: emailFrom,
        subject: environment ? `${environment} : ` : '',
        custom_fields: {
          cf_where_is_the_problem_url_org_proj_file: metadata || ""
        }
      });
    }
  }, [environment, metadata]);
  return null;
};

export default FreshDeskWidget;